module.exports = __webpack_public_path__ + "img/bottom_cloud_001.e625f57e.svg";